import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table table-striped table-sm small" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "align-middle text-nowrap" }
const _hoisted_5 = ["id", "data-bs-target", "aria-controls", "onClick"]
const _hoisted_6 = { class: "align-middle text-end" }
const _hoisted_7 = { class: "d-flex text-nowrap" }
const _hoisted_8 = { class: "flex-fill me-4" }
const _hoisted_9 = { class: "align-middle text-end" }
const _hoisted_10 = { class: "d-flex text-nowrap" }
const _hoisted_11 = { class: "flex-fill me-4" }
const _hoisted_12 = { class: "align-middle text-end" }
const _hoisted_13 = { class: "d-flex text-nowrap" }
const _hoisted_14 = { class: "flex-fill me-4" }
const _hoisted_15 = {
  class: "align-middle text-truncate small",
  style: {"--max-width":"10rem"}
}
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "align-middle" }
const _hoisted_18 = { class: "ms-4 me-1" }
const _hoisted_19 = { class: "text-center small flex-fill me-4 text-truncate" }
const _hoisted_20 = { class: "align-middle text-end" }
const _hoisted_21 = { class: "d-flex text-nowrap" }
const _hoisted_22 = { class: "flex-fill me-4" }
const _hoisted_23 = { class: "small" }
const _hoisted_24 = {
  colspan: "7",
  class: "p-0"
}
const _hoisted_25 = ["id"]
const _hoisted_26 = { class: "col-11 col-md-10 col-lg-10 col-xl-9" }
const _hoisted_27 = { class: "table table-sm small" }
const _hoisted_28 = { class: "align-middle text-center small" }
const _hoisted_29 = {
  key: 0,
  colspan: "3",
  class: "text-center"
}
const _hoisted_30 = {
  key: 1,
  colspan: "3",
  class: "text-center"
}
const _hoisted_31 = { class: "align-middle" }
const _hoisted_32 = { class: "d-flex align-items-center text-nowrap" }
const _hoisted_33 = { class: "ms-4 me-3" }
const _hoisted_34 = { class: "flex-fill me-1" }
const _hoisted_35 = { class: "align-middle small" }
const _hoisted_36 = { class: "align-middle text-end" }
const _hoisted_37 = { class: "d-flex text-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
        _createElementVNode("tr", { class: "fw-bold" }, [
          _createElementVNode("th", { class: "col-2 text-center" }, "Fecha"),
          _createElementVNode("th", { class: "col-2 col-xl-1 text-center" }, "Valor"),
          _createElementVNode("th", { class: "col-2 col-xl-1 text-center" }, "Comisión"),
          _createElementVNode("th", { class: "col-2 col-xl-1 text-center" }, "Total"),
          _createElementVNode("th", {
            class: "",
            style: {"--max-width":"10rem"}
          }, "TX Hash"),
          _createElementVNode("th", { class: "col-2 col-xl-1 text-center" }, "Status"),
          _createElementVNode("th", { class: "col-2 text-center" }, "Pago")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getWithdrawals, (p) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: p._id
          }, [
            _createElementVNode("tr", {
              id: 'row-' + p._id,
              class: _normalizeClass('d-table-row detail-' + p._id)
            }, [
              _createElementVNode("td", _hoisted_4, [
                _createElementVNode("a", {
                  class: "fas fa-chevron-right fa-fw m-1 text-decoration-none link-secondary",
                  role: "button",
                  id: 'dropdown-detail-' + p._id,
                  "data-bs-toggle": "collapse",
                  "data-bs-target": '.detail-' + p._id,
                  "aria-expanded": "false",
                  "aria-controls": '#detail-' + p._id,
                  onClick: ($event: any) => (
                  _ctx.loadCommissionDetails(p.username, p._id, p.commissionsIds)
                )
                }, null, 8, _hoisted_5),
                _createTextVNode(" " + _toDisplayString(_ctx.formatDate(Number(p._id))), 1)
              ]),
              _createElementVNode("td", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "ms-4 me-1" }, "G$", -1)),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.toTwoDecimals(Number(p.amount))), 1)
                ])
              ]),
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ms-4 me-1" }, "G$", -1)),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.toTwoDecimals(Number(p.fee))), 1)
                ])
              ]),
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ms-4 me-1" }, "G$", -1)),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.toTwoDecimals(Number(p.payment))), 1)
                ])
              ]),
              _createElementVNode("td", _hoisted_15, [
                (p.hash == 'pending')
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: _normalizeClass(_ctx.hashIconClass())
                    }, null, 2))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: 
                  'https://blockchair.com/es/bitcoin/transaction/' + p.hash
                ,
                      target: "_blank",
                      class: "link-success"
                    }, _toDisplayString(p.hash), 9, _hoisted_16))
              ]),
              _createElementVNode("td", _hoisted_17, [
                _createElementVNode("div", {
                  class: _normalizeClass('text-nowrap ' + _ctx.statusColorClass(p.status))
                }, [
                  _createElementVNode("span", _hoisted_18, [
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.statusIconClass(p.status) + ' me-1')
                    }, null, 2)
                  ]),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.translateStatus(p.status)), 1)
                ], 2)
              ]),
              _createElementVNode("td", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "ms-4 me-1" }, [
                    _createElementVNode("i", { class: "fab fa-btc" })
                  ], -1)),
                  _createElementVNode("span", _hoisted_22, [
                    _createTextVNode(_toDisplayString(p.paidAmount.toFixed(8)) + " ", 1),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(p.paidCurrency), 1)
                  ])
                ])
              ])
            ], 10, _hoisted_3),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_24, [
                _createElementVNode("div", {
                  id: 'detail-' + p._id,
                  class: _normalizeClass('ms-4 collapse  detail-' + p._id)
                }, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("table", _hoisted_27, [
                      _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "col-2 text-center" }, "Fecha"),
                          _createElementVNode("th", { class: "col-3 text-center" }, "Tipo"),
                          _createElementVNode("th", { class: "col-5" }, "Origen"),
                          _createElementVNode("th", { class: "col-2 text-center" }, "Valor")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commissionsDetailsMap.get(p._id), (c) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: c._id
                          }, [
                            _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.formatDate(c._id)), 1),
                            (c.status == 'loading')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_29, [...(_cache[4] || (_cache[4] = [
                                  _createElementVNode("i", { class: "fas fa-spinner fa-fw fa-spin" }, null, -1),
                                  _createTextVNode(" Cargando .... ", -1)
                                ]))]))
                              : (c.status == 'error')
                                ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                                    _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-alert fa-fw" }, null, -1)),
                                    _createTextVNode(" Error!: " + _toDisplayString(c.source) + " ", 1),
                                    _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-refresh fa-fw" }, null, -1))
                                  ]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createElementVNode("td", _hoisted_31, [
                                      _createElementVNode("div", _hoisted_32, [
                                        _createElementVNode("span", _hoisted_33, [
                                          _createElementVNode("i", {
                                            class: _normalizeClass(_ctx.typeIconClass(c.type))
                                          }, null, 2)
                                        ]),
                                        _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.translateType(c.type)), 1)
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_35, _toDisplayString(c.source), 1),
                                    _createElementVNode("td", _hoisted_36, [
                                      _createElementVNode("div", _hoisted_37, [
                                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "ms-4 me-1" }, "G$", -1)),
                                        _createElementVNode("span", {
                                          class: _normalizeClass(
                                  'flex-fill me-4 ' + _ctx.amountClass(c.status)
                                )
                                        }, _toDisplayString(_ctx.toTwoDecimals(c.amount)), 3)
                                      ])
                                    ])
                                  ], 64))
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ], 10, _hoisted_25)
              ])
            ])
          ], 64))
        }), 128))
      ])
    ])
  ]))
}